<template>
  <div
      class="container"
      style="position: relative"
  >
    <el-breadcrumb
        class="breadcrumb-content"
        separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item
          :key="-1"
          class="iscollapse-box"
      >
      <img @click="operateIscollapse" style="width: 12px;height: 12px;cursor: pointer;" :src="isCollapse?require('../../../assets/images/fold_icon.png'):require('../../../assets/images/unfold_icon.png')" alt="">
      </el-breadcrumb-item>
      <template v-for="(item, index) in breadcrumbList">
        <el-breadcrumb-item
            :to="item.path"
            :key="index"
            @click.native="handleBreadcrumb(index, item)"
        >{{ item.name }}
        </el-breadcrumb-item>
      </template>
    </el-breadcrumb>
    <TabBar
        style="width: calc(100% - 260px);border-left: 1px solid #D3DAE8;"/>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import TabBar from '../TabBar/TabBar'

export default {
  name: 'Breadcrumb',
  components: {
    TabBar
  },
  computed: {
    ...mapState({
      isCollapse: (state) => state.tagsView.isCollapse,
      breadcrumbList: (state) => state.tagsView.breadcrumbList
    })
  },
  methods: {
    handleBreadcrumb(index, item) {
      this.$emit('handleBreadcrumb', index, item)
    },
    operateIscollapse() {
      // document.body.classList.toggle('sidebar-collapsed')
      this.$store.commit('tagsView/SET_ISCOLLAPSE', !this.isCollapse)
    }
  }
}
</script>

<style lang="scss">
.container{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.iscollapse-box {
  font-size: 24px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  .el-breadcrumb__inner{
    display: flex;
    align-items: center;
  }
  .el-breadcrumb__separator {
    display: none !important;
  }

  i{
    cursor: pointer;
  }
}
.el-breadcrumb__item{
  .el-breadcrumb__inner{
    font-size: 12px;
  }
}

.breadcrumb-content {
  display: flex;
  align-items: center;
  line-height: 36px !important;
  width: 260px;
}
</style>
